// Opens the server-generated Work Order PDF (details + comments) in a new browser tab.
// The PDF is produced by WorkOrdersPDFController (GET /api/work-orders/pdf?ids=1,2,3) and
// returned inline, so the browser displays it. Pass one id for a single order or several.
export const openWorkOrderPdf = (
	workOrderIds: (number | null | undefined)[],
): void => {
	const ids = toIds(workOrderIds);
	if (ids.length === 0) return;

	window.open(`/api/work-orders/pdf?ids=${ids.join(",")}`, "_blank");
};

// Opens the printable Task List: every order of one list as a single table, in the order the
// ids are passed. Produced by GET /api/work-orders/pdf-list, also returned inline.
// listTitle is the list's heading ("Down Day Orders"), sectionAssetId the asset the list is
// filtered by; the server turns that id into the section name shown on the printout.
// The file name travels as a path segment, not a parameter: Chrome's PDF viewer names a saved
// file after the last segment of the URL and ignores the Content-Disposition name, so every
// printout used to be saved as "pdf-list.pdf".
export const openTaskListPdf = (
	workOrderIds: (number | null | undefined)[],
	listTitle: string,
	sectionAssetId: number,
): void => {
	const ids = toIds(workOrderIds);
	const query = new URLSearchParams({
		ids: ids.join(","),
		title: listTitle,
		areaId: String(sectionAssetId),
	});
	const fileName = encodeURIComponent(`${listTitle} ${todayStamp()}.pdf`);

	window.open(
		`/api/work-orders/pdf-list/${fileName}?${query.toString()}`,
		"_blank",
	);
};

const todayStamp = (): string => {
	const now = new Date();
	const pad = (value: number) => String(value).padStart(2, "0");
	return `${pad(now.getMonth() + 1)}-${pad(now.getDate())}-${now.getFullYear()}`;
};

const toIds = (workOrderIds: (number | null | undefined)[]): number[] =>
	workOrderIds.filter((id): id is number => typeof id === "number");
